import React, { Component } from 'react';
import onClickOutside from 'react-onclickoutside';
import { connect } from 'react-redux';

import { leaveTrimModeCreator, patchTrimVideoCreator } from 'creators/trimming';

import Button from 'components/ui-components/button';

import './styles.less';

class ReturnToVideoButton extends Component {
  state = {
    show_confirmation_modal: false,
  };

  render() {
    const { show_confirmation_modal: showConfirmationModal } = this.state;
    const { newChanges } = this.props;

    let confirmationModalShowClass = '';

    if (newChanges && showConfirmationModal) {
      confirmationModalShowClass = 'show';
    }

    return (
      <div className="return-to-video-react-container">
        <div className="return-to-video-button" onClick={this.onReturnClicked}>
          <span className="arrow" />
          <span>Return to video</span>
        </div>
        <div
          className={`return-to-video-confirmation-modal ${confirmationModalShowClass}`}
        >
          <p>Are you sure you&apos;d like to discard your changes?</p>
          <div className="button-bar">
            <Button
              buttonClass="return-button"
              value="Discard"
              buttonType="rp-secondary-3"
              onClicked={this.leaveTrimMode}
            />
            <Button
              buttonClass="publish-button"
              value="Publish Changes"
              buttonType="rp-primary-3"
              onClicked={this.onPublishClicked}
            />
          </div>
        </div>
      </div>
    );
  }

  componentDidUpdate(prevProps) {
    // if new changes are made while this dialog is open, set the component state
    // to close the confirmation modal
    if (
      !prevProps.newChanges &&
      this.props.newChanges &&
      this.state.show_confirmation_modal
    ) {
      this.setState({ show_confirmation_modal: false });
    }
  }

  leaveTrimMode = () => {
    this.props.leaveTrimModeCreator();
    this.props.onLeave();
  };

  onReturnClicked = () => {
    if (this.state.show_confirmation_modal) {
      return;
    }

    const { newChanges } = this.props;

    if (newChanges) {
      return this.setState({ show_confirmation_modal: true });
    }

    this.leaveTrimMode();
  };

  onPublishClicked = () => {
    const { video } = this.props;

    this.props.patchTrimVideoCreator(video, this.props.onLeave);
  };

  handleClickOutside() {
    if (!this.state.show_confirmation_modal) {
      return;
    }

    this.setState({ show_confirmation_modal: false });
  }
}

const mapStateToProps = state => {
  const { new_changes: newChanges } = state.trimming;

  return { newChanges };
};

const mapDispatchToProps = dispatch => {
  return {
    leaveTrimModeCreator: () => dispatch(leaveTrimModeCreator()),
    patchTrimVideoCreator: (video, onFinish) =>
      dispatch(patchTrimVideoCreator(video, onFinish)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(onClickOutside(ReturnToVideoButton));
